import React, { useState } from 'react'
import FarmerInspectionForm from './FarmerInspectionForm';
import FarmerInspectionList from './FarmerInspectionList';

const FarmerInspection= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
          <FarmerInspectionForm addForm={setFromIsShown} update={upData} sId={serviceId}/>
        ) : (
          <FarmerInspectionList addForm={setFromIsShown} update={setUpData} sId={setServiceId}/>
        )}
  
    </>
  )
}

export default FarmerInspection;